// Copyright (C) dātma, inc™ - All Rights Reserved
// Unauthorized copying of this file, via any medium is strictly prohibited
// Proprietary and confidential

export const getViewerToolScrollY = (parentDiv) => {
  return parentDiv.children[0].firstElementChild.scrollTop
}

export const setViewerToolScrollY = (parentDiv, scrollTop) => {
  setTimeout(() => {
    parentDiv.children[0].firstElementChild.scrollTop = scrollTop
  }, 50)
}
